import BlogPost from "../../../../src/templates/blog-post";
import { graphql } from 'gatsby';
import Challenge from "../../../../src/flexbox/challenge/6";
import * as React from 'react';
export default {
  BlogPost,
  graphql,
  Challenge,
  React
};